module.exports = __webpack_public_path__ + "img/icon-component-label_BookVideos.48ee1537.svg";